import JournalGroup from './JournalGroup';
import type { WordPressBlogPost, JournalGroupProps, InternalBlogPostItem } from './JournalGroup';

export type { WordPressBlogPost, JournalGroupProps, InternalBlogPostItem };
export default JournalGroup;
